/** Standard gap between app nav and page content (Boron 24px). */
export const ROUTE_NAV_CONTENT_GAP = 24;

/** Standard gap below breadcrumb or tab chrome before main content. */
export const ROUTE_CHROME_CONTENT_GAP = 24;

/** MaxPageWidth `classes` presets for route page shells — Boron 4px scale. */
export const maxPageWidthShellStyleSheet = {
  /** Remove MaxPageWidth top padding when nav-to-content spacing is owned elsewhere. */
  flushTop: {
    paddingTop: 0,
  },
  /** Tab bar shell: flush under app nav; outlet supplies chrome-to-content gap. */
  tabBarShell: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  /** Breadcrumb row flush under nav with standard gap before content below. */
  breadcrumbBar: {
    flexShrink: 0,
    paddingBottom: ROUTE_CHROME_CONTENT_GAP,
  },
  /** Hub/list pages: vertical stack with 24px gap. */
  hubColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: ROUTE_CHROME_CONTENT_GAP,
    width: '100%',
  },
  /** Detail/editor pages: column without inter-block gap. */
  pageColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
} as const;
